import app from 'flarum/common/app';
app.initializers.add('choina-pomagam-parafialnie-common', () => {
  // console.log('[choina/flarum-pomagam-parafialnie] Hello, forum and admin!');
});